import axios from 'axios';
import { API_BASE } from './constants';
import {
    BankInfo,
    SignupExternalBank,
    SignupExternalPartnership,
    SignupExternalSelfEmployed,
    SignupExternalSigner,
    SignupExternalState,
} from './types';

export async function getSignupExternalState(): Promise<{ data: SignupExternalState }> {
    const response = await axios.get(`${API_BASE}/signup_external/state/`);

    return response.data;
}

export async function getSignupExternalType(): Promise<{ data: SignupExternalPartnership }> {
    const response = await axios.get(`${API_BASE}/signup_external/type/`);

    return response.data;
}

export async function postSignupExternalType(
    data: SignupExternalPartnership,
): Promise<{ data: SignupExternalPartnership }> {
    const response = await axios.post(`${API_BASE}/signup_external/type/`, data);

    return response.data;
}

export async function getSignupExternalSelfEmployed(): Promise<{
    data: SignupExternalSelfEmployed;
}> {
    const response = await axios.get(`${API_BASE}/signup_external/self_employed/`);

    return response.data;
}

export async function postSignupExternalSelfEmployed(): Promise<{
    data: SignupExternalSelfEmployed;
}> {
    const response = await axios.post(`${API_BASE}/signup_external/self_employed/`);

    return response.data;
}

export async function getBankInfoByBic(bic: string): Promise<{ data: BankInfo }> {
    const response = await axios.get(`${API_BASE}/signup_external/bic/${bic}/`);

    return response.data;
}

export async function getSignupExternalBank(): Promise<{ data: SignupExternalBank }> {
    const response = await axios.get(`${API_BASE}/signup_external/bank/`);

    return response.data;
}

export async function postSignupExternalBank(
    data: SignupExternalBank,
): Promise<{ data: SignupExternalBank }> {
    const response = await axios.post(`${API_BASE}/signup_external/bank/`, data);

    return response.data;
}

export async function getSignupExternalSigner(): Promise<{ data: SignupExternalSigner }> {
    const response = await axios.get(`${API_BASE}/signup_external/signer/`);

    return response.data;
}

export async function postSignupExternalSigner(
    data: SignupExternalSigner,
): Promise<{ data: SignupExternalSigner }> {
    const response = await axios.post(`${API_BASE}/signup_external/signer/`, data);

    return response.data;
}

export async function submitSignupExternal(): Promise<{ result: string }> {
    const response = await axios.post(`${API_BASE}/signup_external/submit/`);

    return response.data;
}

export async function downloadOfferPdf(): Promise<Blob> {
    const response = await axios.get(`${API_BASE}/signup_external/pdf/`, {
        responseType: 'blob',
    });

    return response.data;
}
